import _ from 'lodash';
import React, { Fragment } from 'react';
import classNames from 'classnames';
import Chip from '@material-ui/core/Chip';
import { PositionsIcon } from '../../../components/icons';

const PositionChip = (props) => {
   const { name, className, disableDelete = false, ...rest } = props;

   const rootClasses = classNames('PositionChip', className);

   const caption = name;

   const onDeleteHandler = !disableDelete ? rest.onDelete : undefined;

   return (
      <div className={rootClasses}>
         <Chip icon={<PositionsIcon />} className={'chip'} label={caption} {...rest} onDelete={onDeleteHandler} />
      </div>
   );
};

export default PositionChip;
